import { render, staticRenderFns } from "./Acompanhamento.vue?vue&type=template&id=8b3be70c&scoped=true&"
import script from "./Acompanhamento.vue?vue&type=script&lang=ts&"
export * from "./Acompanhamento.vue?vue&type=script&lang=ts&"
import style0 from "./Acompanhamento.vue?vue&type=style&index=0&id=8b3be70c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3be70c",
  null
  
)

export default component.exports